import { measureText } from '../util';

/** 存放一些业务方可能会在扩展功能里用到的工具方法 */
export const VCHART_UTILS = {
  measureText
};
